import { Pipe, PipeTransform } from "@angular/core";
import { getColorByString } from "src/app/support/colors";

@Pipe({
  name: "colorByString",
  standalone: false
})
export class ColorByStringPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return "#000000";
    }

    return getColorByString(value);
  }
}
